/* eslint-disable indent */
/* eslint-disable max-len */
import React, { useCallback, useEffect,useState,useContext } from "react"
import TopHeader from "../../components/TopHeader"
import { motion } from 'framer-motion'
import { Link } from "react-router-dom"
import { useParams,useLocation,useNavigate,useSearchParams } from "react-router-dom"
import {useDispatch, useSelector} from 'react-redux'
import CustomOverLay from "../../components/CustomOverLay"
import GlobalContext from "../../components/Context/GloablContext"
import SearchEmptyScreen from "../../components/SearchEmptyScreen"
import formatMobileNumber from "../../CommonMethods/FormatMobileNumber"
import { convertEpochToDateFormat } from "../../CommonMethods/DateConversion"
import { useViewObserverQuery } from "../../features/observerSlice"
import { handleEditMessageSent } from "../../redux/systemConfigSlice"
import HelpGuideModal from '../../components/HelpGuideModal'
import {useGetHelpGuideAdminQuery} from '../../features/patientSlice'
import OtpPreferenceList from "../../components/OtpPreferenceList/OtpPreferenceList"
import { resetObserverSearch } from "../../redux/observerSearchSlice"

export default function ViewObserver(){
    const navigate=useNavigate()
    const [searchParams,setSearchParams] =useSearchParams()
    const {isSideBar,sendMessageToStartEditing,editSocket,setToastErrorMessage,setIsAdvancedSearchOpen} = useContext(GlobalContext)
    const location=useLocation();
    const dispatch = useDispatch()
    const messageSent = useSelector(state=>state?.systemConfigData?.messageSent)
    const [viewObserverDetails,setViewObserverDetails]=useState("");
    const [loading,setLoading]=useState(true)
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    
    
    
     useEffect(() => {
        if (userType === 'corporate-user') {
            setQueryParamsadmin('type=corporate-view-observers');
        } else {
            setQueryParamsadmin('type=admin-observers-view-observers');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);

    const {id}=useParams()
    const {data,isFetching,status}=useViewObserverQuery(id, {refetchOnMountOrArgChange: true})
    useEffect(()=>{
      if(data!==undefined){
        setViewObserverDetails(data[0])
      }
    },[data])

    const handleEditButtonClick = () =>{
        if(!messageSent){
            sendMessageToStartEditing(viewObserverDetails?.user_id)
            let message
            editSocket.onmessage = (event) =>{
                message = event.data
                if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                    navigate(`/manage-observer/edit-observer/${id}`,{state:[location.state,true,id]})
                    dispatch(resetObserverSearch())
                    setIsAdvancedSearchOpen(false)
                } else{
                    dispatch(handleEditMessageSent(false))
                    { (JSON.parse(message)?.adminId) &&
                        setToastErrorMessage(`A user with username ${decodeURIComponent( JSON.parse(message)?.adminId)} is already editing this observer`)
                    }
                }
            }    
        }
    }   

    
    //const date=dateformat?.includes('AM/PM')?moment(data?.created_at+'Z')?.utcOffset('+05:30')?.format(`${dateformat?.split(',')[0]} hh:mm:ss A`):moment(data?.data?.created_at).format(dateformat)
    const date=convertEpochToDateFormat(viewObserverDetails?.created_at,dateformat)
    return(
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Manage Observers"}/>
                {/* isFetching&&status!=="fulfilled" */}
                {isFetching&&status!=="fulfilled"?<CustomOverLay Active text="Loading Observer Details..." classKey={`absolute top-0 left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar?'opened-sidebar-config':'system_config_overlay'}`}/>:status==="rejected"?<SearchEmptyScreen text={"No data found"} />:<>

                    <div className='bg-white rounded-lg py-[12px] px-[30px] h-customh3'>
                        <motion.div 
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{duration:0.5}}
                        >
                            <div className='bg-white'>
                                <div className='flex items-center mb-[22px]'>
                                    <Link to="/manage-observer" state={Array.isArray(location.state)?'':location.state}>
                                        <h1 className="text-sm font-normal text-[#52555D]">List of Observers</h1>
                                    </Link>
                                    <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                    <h1 className="text-sm font-normal text-[#008586]">View Observer</h1>
                                    {
                userType !=='super-admin' &&
                <span   onClick={() => setHelpGuideModel(true)} className=' ml-auto mr-9 cursor-pointer'>
                    <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                </span> 
            }
                                </div>
                                <div className="flex items-center pb-3 pr-9">
                                    <Link to={`/manage-observer`} state={Array.isArray(location.state)?'':location.state} className='flex items-center min-w-max z-[99]'>
                                        <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                        <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Listing</span>
                                    </Link>
                                    <h1 className='text-xl font-normal text-[#000000] text-center w-full xl:-ml-[146px]'>
                                        View Observer
                                    </h1>
                                    <div className="xl:hidden block">
                                        <button onClick={handleEditButtonClick}  id="edit" type='button' className={`min-w-max px-4 py-2 border border-[#972E4C] h-fit rounded-[16px] flex items-center ml-4`}>
                                            <span className='w-5'><img src="/images/edit_icon.svg" alt="icon"/></span>
                                            <span className='pl-2.5 text-lg font-normal text-[#972E4C]'>Edit</span>
                                        </button>
                                    </div>
                                </div>
                                <div>
                                    <div className="flex justify-between items-center pl-[30px] xl:pr-11 pr-10">
                                        <div className="flex items-center">
                                            <p className="text-xl font-semibold text-[#000000]">{viewObserverDetails?.first_name} {viewObserverDetails?.last_name}</p>
                                            <p className="text-sm font-normal text-[#000000] px-2">{viewObserverDetails?.user_id}</p>
                                            {viewObserverDetails?.status=='inactive' ? <p className="px-3 py-1.5 bg-[#C5C9DA] rounded-[16px] text-sm font-semibold text-[#52555D]">Inactive</p> : 
                                            <p className="px-3 py-1.5 bg-[#CCE7E7] rounded-[16px] text-sm font-semibold text-[#006A6B]">Active</p>
                                            }
                                        </div>
                                        <div className="flex items-center">
                                            <button type="button" 
                                                onClick={()=>{ navigate('/manage-observer/activity_history', { state: [viewObserverDetails.user_name, true, id, Array.isArray(location.state) ? '' : location.state] }),
                                                dispatch(resetObserverSearch()),
                                                setIsAdvancedSearchOpen(false) 
                                            }}
                                                className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] 
                                        rounded-[16px] bg-[#972E4C] hover:bg-[#AB556E] min-w-max
                                            focus:bg-[#863B50] disabled:bg-[#777C88] xl:mr-4 ml-2 ${userType==='corporate-user'?'hidden':''}`}>
                                                View Activity Log 
                                            </button>
                                            <div className="xl:block hidden">
                                                <button onClick={handleEditButtonClick}  id="edit" type='button' className={`min-w-max px-4 py-2.5 border border-[#972E4C] h-fit rounded-[16px] flex items-center`}>
                                                    <span className='w-5'><img src="/images/edit_icon.svg" alt="icon"/></span>
                                                    <span className='pl-2.5 text-lg font-normal text-[#972E4C]'>Edit</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="h-customh9 overflow-auto scrollbar_purple pr-2.5 mt-[26px]">
                                        <div className="w-full px-6">
                                            <div className="bg-[#E7EAF4] rounded-lg p-6">
                                                <div className="flex -mx-1 flex-wrap">
                                                    {/* Row 1: Username, Email, Mobile Number, Main Number */}
                                                    <div className="w-1/4 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Username</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewObserverDetails?.user_name}</p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/4 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Email Address</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewObserverDetails?.email_address!==""?viewObserverDetails?.email_address:'-'}</p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/4 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Mobile Number</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewObserverDetails?.mobile_number!==""?viewObserverDetails.mobile_country_code+" "+formatMobileNumber(viewObserverDetails?.mobile_number):"-"}</p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/4 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Main Number</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewObserverDetails.main_country_code} {formatMobileNumber(viewObserverDetails.main_number)}</p>
                                                        </div>
                                                    </div>
                                                    {/* Row 2: Address (1st col), Created Date (2nd col), empty columns 3-4 */}
                                                    <div className="w-1/4 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Address</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewObserverDetails.address!==""?viewObserverDetails.address:'-'}</p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/4 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Created Date</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {date}</p>
                                                        </div>
                                                    </div>
                                                    {/* Empty placeholders to force alerts to next row */}
                                                    <div className="w-1/4 px-1 mb-5"></div>
                                                    <div className="w-1/4 px-1 mb-5"></div>
                                                    {/* Row 3: All four alerts in separate columns */}
                                                    <div className="w-1/4 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000000] mb-2">Alerts by SMS</p>
                                                            <div className="flex justify-start">
                                                                <span className="inline-flex items-center justify-start text-sm font-normal bg-[#E7EAF4] text-[#000000] px-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px] -ml-[10px]">
                                                                    {(viewObserverDetails?.sms_alert === true || viewObserverDetails?.sms_alert === "true" || viewObserverDetails?.sms_alert === 1) ? "ON" : "OFF"}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/4 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000000] mb-2">Alerts by Email</p>
                                                            <div className="flex justify-start">
                                                                <span className="inline-flex items-center justify-start text-sm font-normal bg-[#E7EAF4] text-[#000000] px-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px] -ml-[10px]">
                                                                    {(viewObserverDetails?.email_alert === true || viewObserverDetails?.email_alert === "true" || viewObserverDetails?.email_alert === 1) ? "ON" : "OFF"}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/4 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000000] mb-2">Include Missed Readings</p>
                                                            <div className="flex justify-start">
                                                                <span className="inline-flex items-center justify-start text-sm font-normal bg-[#E7EAF4] text-[#000000] px-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px] -ml-[10px]">
                                                                    {(viewObserverDetails?.missed_reading_alert === true || viewObserverDetails?.missed_reading_alert === "true" || viewObserverDetails?.missed_reading_alert === 1) ? "ON" : "OFF"}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/4 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000000] mb-2">Receive Readings Acknowledgement</p>
                                                            <div className="flex justify-start">
                                                                <span className="inline-flex items-center justify-start text-sm font-normal bg-[#E7EAF4] text-[#000000] px-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px] -ml-[10px]">
                                                                    {(viewObserverDetails?.reading_received_alert === true || viewObserverDetails?.reading_received_alert === "true" || viewObserverDetails?.reading_received_alert === 1) ? "ON" : "OFF"}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {<div className="bg-[#E7EAF4] rounded-lg p-6 mt-6">
                                                <div className="flex -mx-1 flex-wrap">
                                                    <div className="w-1/3 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Organization Name</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewObserverDetails?.organization_name !== undefined && viewObserverDetails?.organization_name !== "" 
                                                                    ? viewObserverDetails?.organization_name 
                                                                    : '-'}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-1 mb-5">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Sub Division Name</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewObserverDetails?.subdivision_name !== undefined && viewObserverDetails?.subdivision_name !== "" 
                                                                        ? viewObserverDetails?.subdivision_name 
                                                                        : '-'}   
                                                            </p>                                                     
                                                                    
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {/* otp list */}
                                            <OtpPreferenceList
                                                username={viewObserverDetails?.user_name}
                />
                                            {data[0]?.patient_id!==undefined&&<div>
                                                <p className=' pt-2.5 min-w-fit text-base font-semibold text-[#972E4C] relative mt-5 mb-5'>
                                                    Patient Details
                                                </p>
                                                <div className='border border-[#EDD7E1] rounded-lg flex flex-col p-4  mt-3'>
                                                    <div className='flex xl:gap-[60px] gap-[10px]'>
                                                        <div>
                                                            <div>
                                                                <p className='mb-2'>Patient ID</p>
                                                                <p className='mb-6 text-[#031624]'>{data[0]?.patient_id}</p>
                                                            </div>
                                                            <div>
                                                                <p className='mb-2'>First Name</p>
                                                                <p className='mb-6 text-[#031624]' style={{lineBreak:"anywhere"}}>{data[0]?.patient_first_name}</p>
                                                            </div>
                                                            <div>
                                                                <p className='mb-2'>Date of Birth</p>
                                                                <p className='mb-6 text-[#031624]'>{data[0]?.patient_date_of_birth}</p>
                                                            </div>
                                                            <div>
                                                                <p className='mb-2'>Primary Identifier</p>
                                                                <p className='mb-6 text-[#031624]'>{data[0]?.patient_primary_identifier}</p>
                                                            </div>
                                                            <div>
                                                                <p className='mb-2'>Email Address</p>
                                                                <p className='mb-6 text-[#031624]'>{data[0]?.patient_email_address}</p>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div>
                                                                <p className='mb-2'>Username</p>
                                                                <p className='mb-6 text-[#031624]'>{data[0]?.patient_user_name}</p>
                                                            </div>
                                                            <div>
                                                                <p className='mb-2'>Middle Name</p>
                                                                <p className='mb-6 text-[#031624]' style={{lineBreak:"anywhere"}}>{data[0]?.patient_middle_name!==''?data[0]?.patient_middle_name:'-'}</p>
                                                            </div>
                                                            <div>
                                                                <p className='mb-2'>Age</p>
                                                                <p className='mb-6 text-[#031624]'>{data[0]?.patient_age}</p>
                                                            </div>
                                                            <div>
                                                                <p className='mb-2'>Secondary Identifier</p>
                                                                <p className='mb-6 text-[#031624]'>{data[0]?.patient_secondary_identifier!==''?data[0]?.patient_secondary_identifier:'-'}</p>
                                                            </div>
                                                            <div>
                                                                <p className='mb-2'></p>
                                                                <p className='mb-6 text-[#031624]'></p>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div>
                                                                <p className='mb-2'></p>
                                                                <p className='mb-[80px]'></p>
                                                            </div>
                                                            <div>
                                                                <p className='mb-2'>Last Name</p>
                                                                <p className='mb-6 text-[#031624]' style={{lineBreak:"anywhere"}}>{data[0]?.patient_last_name}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {(helpGuideModel && helpguidestatus==="fulfilled") &&
                            <HelpGuideModal
                                setHelpGuideModel={setHelpGuideModel}
                                pdfUrl={helpguidedata} // Pass the PDF URL to the modal
            />
            }
            
                            
                        </motion.div>
                    </div>
                   
                                           
                </>}
            </div>
        </>
    )
}